import React from 'react';
interface QuoteFlowProps {
  product: any;
  isOpen: boolean;
  onClose: () => void;
}
export const QuoteFlow: React.FC<QuoteFlowProps> = ({
  product,
  isOpen,
  onClose
}) => {
  if (!isOpen) return null;
  return <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" data-id="element-3872">
      <div className="bg-white rounded-lg p-6 max-w-2xl w-full mx-4" data-id="element-3873">
        <h2 className="text-2xl font-bold mb-4" data-id="element-3874">
          Create Quote for {product.title}
        </h2>
        <div className="space-y-4" data-id="element-3875">
          {/* Quote flow content will go here */}
          <p className="text-gray-600" data-id="element-3876">
            Quote creation interface coming soon...
          </p>
        </div>
        <div className="mt-6 flex justify-end" data-id="element-3877">
          <button onClick={onClose} className="px-4 py-2 bg-gray-100 text-gray-700 rounded-md hover:bg-gray-200 mr-2" data-id="element-3878">
            Cancel
          </button>
          <button className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700" data-id="element-3879">
            Create Quote
          </button>
        </div>
      </div>
    </div>;
};